import { SampleTable } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { type MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { SerieRowKardex, useModalKardexSeriesStore } from "../hook/useModalKardexSeriesStore.store";
import { Button } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { openGenericObjectModalAsync } from "@/shared/components/ui/ModalGenericObject/useGenericObjectModalStore";
import { toast } from "react-toastify";
import { getSerieByProveedor } from "@/shared/actions/erp";
import { fieldProveedor } from "@/shared/utils/fields-modal-generic-object";
import { handleAxiosError } from "@/shared";

export default function ModalKardexSeries() {

  const series = useModalKardexSeriesStore(s => s.series);
  const setOpen = useModalKardexSeriesStore(s => s.setOpen);
  const open = useModalKardexSeriesStore(s => s.open);
  const movimientoInventario = useModalKardexSeriesStore(s => s.movimientoInventario);

  const columns = useMemo<MRT_ColumnDef<SerieRowKardex>[]>(
    () => [
      {
        accessorKey: 'serie',
        header: 'Serie',
      },
      {
        accessorKey: 'proveedor',
        header: 'Proveedor',
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              startIcon={<OpenInNewIcon />}
              onClick={async () => {
                try {

                  
                  const {
                    serie
                  } = row.original

                  const resp = await getSerieByProveedor(movimientoInventario!)

                  if (!serie) {
                    toast.info('Ingresar una serie.')
                    return;
                  }

                  openGenericObjectModalAsync({
                    fetcher: async () => {
                      return resp.data
                    },
                    fields: fieldProveedor,
                    title: "🌐 Información Proveedor",
                    emptyFallback: "—",
                  });

                } catch (error) {
                  handleAxiosError(error)
                }

              }}
            >VER</Button>
          )
        }
      },
    ],
    [movimientoInventario?.movimiento_inventario],
  );

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title="🖇️Serie"
        cancelTextBtn="Cerrar"
        onClose={() => setOpen(false)
        }
        minWidth="40%"
        contentNode={
          <>
            <SampleTable<SerieRowKardex>
              isLoading={false}
              data={series || []}
              columns={columns}
              enablePagination
            />
          </>
        }
      />
    </>
  )

}